/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     消息中心-通知 API 接口
  | @Version:   2018-12-16  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getNoticeListApi(query) {
  return request({
    url: '?c=fnc&a=notice&do=list',
    method: 'get',
    params: query
  })
}

export function readNoticeApi(id) {
  return request({
    url: '?c=fnc&a=notice&do=read',
    method: 'get',
    params: { id }
  })
}

export function getNewNoticeListApi(query) {
  return request({
    url: '?c=fnc&a=notice&do=newlist',
    method: 'get',
    params: query
  })
}
